import { render, staticRenderFns } from "./propsFlow.vue?vue&type=template&id=7fc7dcf5&scoped=true"
import script from "./propsFlow.vue?vue&type=script&lang=js"
export * from "./propsFlow.vue?vue&type=script&lang=js"
import style0 from "./propsFlow.vue?vue&type=style&index=0&id=7fc7dcf5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc7dcf5",
  null
  
)

export default component.exports